import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MdbSidenavComponent } from 'mdb-angular-ui-kit/sidenav';
import {
  ThreatPair,
  ThreatPairUser,
} from 'src/app/components/common/threat-pair-table/threat-pair-table.model';

@Component({
  selector: 'app-perpetrator-sidebar',
  templateUrl: './perpetrator-sidebar.component.html',
  styleUrls: ['./perpetrator-sidebar.component.scss'],
  standalone: false,
})
export class PerpetratorSidebarComponent {
  @Input() counterpartRole: 'Survivor' | 'Perpetrator' = 'Perpetrator';
  @Input() counterpartUser?: ThreatPairUser;
  @Input() selectedPair: ThreatPair | null = null;

  @Output() alertClick = new EventEmitter<ThreatPair>();

  @ViewChild('sidenav', { static: false }) public sidenav!: MdbSidenavComponent;

  onOpen(): void {
    this.sidenav.toggle();
  }

  onClose(): void {
    this.sidenav.toggle();
  }

  onAlert(): void {
    if (this.selectedPair) {
      this.alertClick.emit(this.selectedPair);
    }
  }
}
